// Action Types
export const VM_GET_AGENCY_INVOICES = "VM_GET_AGENCY_INVOICES";
export const VM_SET_AGENCY_INVOICES = "VM_SET_AGENCY_INVOICES";
export const VM_EDIT_AGENCY_INVOICE = "VM_EDIT_AGENCY_INVOICE";
export const VM_DOWNLOAD_INVOICE = "VM_DOWNLOAD_INVOICE"; // placeholder
export const VM_RESEND_AGENCY_INVOICE = "VM_RESEND_AGENCY_INVOICE";

// Action Creators
export const getAgencyInvoices = (query, cb = () => {}) => ({
  type: VM_GET_AGENCY_INVOICES,
  query,
  cb,
});

export const setAgencyInvoices = (
  data = {
    result: [],
    count: 0,
  }
) => ({
  type: VM_SET_AGENCY_INVOICES,
  payload: data,
});

export const editAgencyInvoice = (payload, cb = () => {}) => ({
  type: VM_EDIT_AGENCY_INVOICE,
  payload,
  cb,
});

export const downloadInvoice = (invoiceId, cb = () => {}) => ({
  type: VM_DOWNLOAD_INVOICE,
  invoiceId,
  cb,
});

export const resendAgencyInvoice = (invoiceId, cb = () => {}) => ({
  type: VM_RESEND_AGENCY_INVOICE,
  invoiceId,
  cb,
});
